import useGlobalState from '../useGlobalState';
import {AuthState} from '../../model/AuthState';

export const useAuthGlobalState = () => {
  return useGlobalState<AuthState>(['auth'], {
    token: undefined,
    refreshToken: undefined,
    clientId: undefined,
    loginType: undefined,
    isLoggedIn: false,
    isLoggingIn: false,
    codeVerifier: undefined,
    autoStartToken: undefined,
    loginToken: undefined,
    stateId: undefined,
    refreshExpireAt: undefined,
    links: undefined,
    serverTimeOffset: 0,
  });
};
